module.exports = __webpack_public_path__ + "static/media/video-thumbnail.0646b8c6.jpg";